import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { PartNumberModel } from './partNumber.model'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { PartNumberService } from './partNumber.service'
import { MatDialog } from '@angular/material/dialog'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-part-number',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './partNumber.component.html',
  styleUrl: './partNumber.component.css',
})
export class PartNumberComponent {
    partnumberColumns: MasterDatabaseDisplayModel[] = [
      {
        key: 'partName',
        displayName: 'Part Name',
        hiddenDataTable: false,
        hiddenDialog: false,
        type: 'text',
      },
      {
        key: 'description',
        displayName: 'Description',
        hiddenDataTable: false,
        hiddenDialog: false,
        type: 'text',
      },
      {
        key: 'addedOn',
        displayName: 'Added Date',
        hiddenDataTable: false,
        hiddenDialog: true,
        type: 'date',
      },
      {
        key: 'id',
        displayName: 'Id',
        hiddenDataTable: true,
        hiddenDialog: true,
        type: 'text',
      },
    ]

    isLoading: boolean = false
    
      constructor(
        private partnumberService: PartNumberService,
        private toastr: ToastrService,
        private dialog: MatDialog,
        public masterCommonService: MasterCommonServices,
      ) {
        this.masterCommonService.getAllPartNumbers()
      }
    
      openAddUpdatePartNumberDialog(mode: string, partnumber?: PartNumberModel): void {
        const fields = this.partnumberColumns
        const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
          data: { item: partnumber || {}, mode, fields },
        })
    
        dialogRef.afterClosed().subscribe((result) => {
          
    
          if (result) {
            if (mode === 'update') {
              this.updatePartNumber(result)
            } else {
              this.addPartNumber(result)
            }
          }
        })
      }
    
      addPartNumber(partnumber: any): void {
        
        this.partnumberService.addPartNumber(partnumber).subscribe({
          next: () => {
            this.toastr.success('Part Number Added Successfully!', 'Success')
            this.masterCommonService.getAllPartNumbers()
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    
      updatePartNumber(partnumber: any): void {
        this.partnumberService.updatePartNumber(partnumber).subscribe({
          next: () => {
            this.toastr.success('Part Number Updated Successfully!', 'Success')
            this.masterCommonService.getAllPartNumbers()
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    
      deletePartNumber(partnumber: PartNumberModel): void {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          data: { message: 'Are you sure you want to delete this partnumber?' },
        })
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed) {
            partnumber.isDeleted = true
            this.partnumberService.deletePartNumber(partnumber).subscribe({
              next: () => {
                this.masterCommonService.partNumberList = this.masterCommonService.partNumberList.filter(
                  (p) => p.id !== partnumber.id,
                )
                this.toastr.success('Part Number Deleted Successfully!', 'Success')
              },
              error: (error: any) => {
                this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
              },
            })
          }
        })
      }
}
